import React from "react";
import { usePdpSellingPlan, usePdpVariant, usePdpProduct } from "./PdpContext";
import { PriceDisplay } from "@/features/product/PriceDisplay";
import { DroppsProduct, productSelect, variantSelect } from "@/store";
import { ProductCard, ProductCardValue } from "../product/ProductCard";

export const WhatsIncluded = ({
  bundledItems,
  overrideFutureShipments,
}: {
  bundledItems: DroppsProduct[];
  overrideFutureShipments?: string;
}) => {
  const variant = usePdpVariant();
  const sellingPlan = usePdpSellingPlan();
  const product = usePdpProduct();

  const bundleSubVariants = bundledItems.flatMap((bundled) => {
    const variant = productSelect.defaultVariant(bundled);
    return variant.subscription === undefined
      ? []
      : [
          {
            bundled,
            subscriptionPrice: variantSelect.lowestPrice(variant, product),
          },
        ];
  });

  return (
    <div className="flex w-full flex-col space-y-4">
      <ul className="flex flex-col">
        {bundledItems.map((product) => {
          const featuredImage = productSelect.featuredImage(product);
          const productCardProduct: ProductCardValue = {
            featuredImage: { ...featuredImage, src: featuredImage.url },
            size: variantSelect.sizeFormat(
              productSelect.defaultVariant(product)
            ),
            title: product.title,
            price: undefined,
          };
          return (
            <ProductCard
              className="-m-3"
              bordered={false}
              hoverable={false}
              key={product.handle}
              compact
              productCardValue={productCardProduct}
            />
          );
        })}
      </ul>
      {bundleSubVariants.length > 0 && variant.subscription && sellingPlan && (
        <>
          <div className="flex justify-between">
            <p className="body font-semibold">{"Today's Total:"}</p>
            <PriceDisplay
              standardPrice={variant.compareAtPrice ?? variant.price}
              discountPrice={variantSelect.lowestPrice(variant, product)}
              showDiscountPrice={
                !!variantSelect.subscriptionDiscount(variant, product)
              }
            />
          </div>
        </>
      )}
      {overrideFutureShipments && (
        <>
          <div className="border-0 border-t border-solid border-primary-200" />
          <p className="text-sm italic">{overrideFutureShipments}</p>
        </>
      )}
    </div>
  );
};
